export enum BatteryType {
  BATTERY_NEW = 'BATTERY_NEW',
  BATTERY_90_99 = 'BATTERY_90_99',
  BATTERY_STANDARD = 'BATTERY_STANDARD',
}

enum Grade {
  PREMIUM = 9,
}

enum OfferType {
  NORMAL = 0,
  NEW_BATTERY = 7,
  BATTERY_90_99 = 9,
}

enum MarketplaceCategoryID {
  SMARTPHONE = 2,
}

export function getBatteryType(
  grade: number,
  offerType: number,
  marketplaceCategoryId: number,
) {
  let batteryType = null

  if (grade !== Grade.PREMIUM) {
    if (offerType === OfferType.NEW_BATTERY) {
      batteryType = BatteryType.BATTERY_NEW
    } else if (offerType === OfferType.BATTERY_90_99) {
      batteryType = BatteryType.BATTERY_90_99
    } else if (marketplaceCategoryId === MarketplaceCategoryID.SMARTPHONE) {
      batteryType = BatteryType.BATTERY_STANDARD
    }
  }

  return batteryType
}
